import { render, staticRenderFns } from "./voucherInquiry.vue?vue&type=template&id=5b8cd9fc&scoped=true"
import script from "./voucherInquiry.vue?vue&type=script&lang=js"
export * from "./voucherInquiry.vue?vue&type=script&lang=js"
import style0 from "./voucherInquiry.vue?vue&type=style&index=0&id=5b8cd9fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cd9fc",
  null
  
)

export default component.exports